// shared-types/src/collection/types.ts

/**
 * Entidad Collection
 * Define colecciones de productos para merchandising y agrupaciones flexibles.
 * Similar al modelo de Shopify Collections.
 */

export enum CollectionType {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC',
}

export enum CollectionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SCHEDULED = 'SCHEDULED',
}

export enum CollectionRulesLogic {
  ALL = 'ALL',
  ANY = 'ANY',
}

export enum CollectionRuleField {
  TAG = 'TAG',
  PRICE = 'PRICE',
  CATEGORY = 'CATEGORY',
  BRAND = 'BRAND',
  TITLE = 'TITLE',
  STATUS = 'STATUS',
  INVENTORY = 'INVENTORY',
  CREATED_AT = 'CREATED_AT',
}

export enum CollectionRuleOperator {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
  CONTAINS = 'CONTAINS',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  IS_SET = 'IS_SET',
  IS_NOT_SET = 'IS_NOT_SET',
}

export interface CollectionRule {
  field: CollectionRuleField;
  operator: CollectionRuleOperator;
  value: string | number | boolean | null;
}

export interface CollectionMedia {
  id: string;
  url: string;
  name?: string;
}

export interface Collection {
  id: string;
  accountId: string;
  name: string;
  slug: string;
  description?: string;
  imageId?: string;
  image?: CollectionMedia | null;
  collectionType: CollectionType;
  status: CollectionStatus;
  isFeatured: boolean;
  rules?: CollectionRule[];
  rulesLogic: CollectionRulesLogic;
  publishAt?: Date;
  unpublishAt?: Date;
  order: number;
  productCount?: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
}

export interface CollectionProductLink {
  collectionId: string;
  productId: string;
  accountId: string;
  displayOrder: number;
  addedAt: Date;
}

export interface CreateCollectionDTO {
  accountId: string;
  name: string;
  description?: string;
  imageId?: string;
  collectionType: CollectionType;
  status?: CollectionStatus;
  isFeatured?: boolean;
  rules?: CollectionRule[];
  rulesLogic?: CollectionRulesLogic;
  publishAt?: Date;
  unpublishAt?: Date;
  order?: number;
  products?: string[];
}

export interface UpdateCollectionDTO {
  name?: string;
  description?: string;
  imageId?: string | null;
  collectionType?: CollectionType;
  status?: CollectionStatus;
  isFeatured?: boolean;
  rules?: CollectionRule[];
  rulesLogic?: CollectionRulesLogic;
  publishAt?: Date | null;
  unpublishAt?: Date | null;
  order?: number;
}

export const CollectionRuleFieldLabels: Record<CollectionRuleField, string> = {
  [CollectionRuleField.TAG]: 'Etiqueta',
  [CollectionRuleField.PRICE]: 'Precio',
  [CollectionRuleField.CATEGORY]: 'Categoría',
  [CollectionRuleField.BRAND]: 'Marca',
  [CollectionRuleField.TITLE]: 'Nombre del producto',
  [CollectionRuleField.STATUS]: 'Estado',
  [CollectionRuleField.INVENTORY]: 'Inventario',
  [CollectionRuleField.CREATED_AT]: 'Fecha de creación',
};

export const CollectionRuleOperatorLabels: Record<CollectionRuleOperator, string> = {
  [CollectionRuleOperator.EQUALS]: 'Es igual a',
  [CollectionRuleOperator.NOT_EQUALS]: 'No es igual a',
  [CollectionRuleOperator.CONTAINS]: 'Contiene',
  [CollectionRuleOperator.GREATER_THAN]: 'Mayor que',
  [CollectionRuleOperator.LESS_THAN]: 'Menor que',
  [CollectionRuleOperator.IS_SET]: 'Está definido',
  [CollectionRuleOperator.IS_NOT_SET]: 'No está definido',
};

export const CollectionTypeLabels: Record<CollectionType, string> = {
  [CollectionType.MANUAL]: 'Manual',
  [CollectionType.AUTOMATIC]: 'Automática',
};

export const CollectionStatusLabels: Record<CollectionStatus, string> = {
  [CollectionStatus.ACTIVE]: 'Activa',
  [CollectionStatus.INACTIVE]: 'Inactiva',
  [CollectionStatus.SCHEDULED]: 'Programada',
};
